import { CMP_PREFIX, THEME_PREFIX } from "@/base/constant";
import { Affix as AntdAffix, AffixProps as AntdAffixProps } from "antd";
import { forwardRef } from "react";
import { useAffixStyle } from "./theme/Affix.styles";

export interface AffixProps extends AntdAffixProps {}

export const affixPrefixCls = `${CMP_PREFIX}-affix`;

export const Affix = forwardRef<any, AffixProps>(
  ({ className, ...props }, ref) => {
    useAffixStyle(affixPrefixCls);

    return (
      <AntdAffix
        ref={ref}
        className={`${THEME_PREFIX} ${className || ""}`}
        {...props}
      />
    );
  },
);

Affix.displayName = "Affix";
